import { SkeletonLoader } from '@twilio-paste/core/skeleton-loader';
import { Stack } from '@twilio-paste/core/stack';

const defaultWidths = ['80%', '60%', '40%', '20%'];

export interface ViewLoadingStateProps {
  widths?: string[];
}

export const ViewLoadingState = ({ widths = defaultWidths }: ViewLoadingStateProps) => (
  <Stack orientation="vertical" spacing="space40" role="progressbar">
    {widths.map(width => (
      <SkeletonLoader width={width} key={width} />
    ))}
  </Stack>
);
